<template>
    <span class="terminal-simulator">
        <div v-html="displayedText" class="displayed-text"></div>
        <TerminalLineCursor class="inline-cursor"/>
    </span>
</template>

<script>
import TerminalLineCursor from '../components/TerminalLineCursor.vue';
import { usePageLoadingStore } from '../stores/pageLoadingStore.js';

export default {
    setup() {
        const pageLoadingStore = usePageLoadingStore();
        return {
            pageLoadingStore
        }
    },
    __name: 'TerminalSimulator',
    props: {
        text: String,
        isWritten: Boolean,
        referrer: String,
        writeSpeed: String,
    },
    components: {
        TerminalLineCursor
    },
    data() {
        return {
            displayedText: "",
        };
    },
    methods: {
        writeStream(text, target) {
            let index = 0;
            const interval = parseInt(this.writeSpeed) || 40;
            
            return new Promise((resolve) => {
                const typingEffect = () => {
                    if (index < text.length) {
                        this.pageLoadingStore.setDisplayedText(this.referrer, this[target] += text[index]);
                        index++;
                        setTimeout(typingEffect, interval);
                    } else {
                        resolve(true);
                    }
                };

                if (text) {
                    typingEffect();
                }
            });
        }
    },
    mounted() {
        this.displayedText = this.pageLoadingStore.getDisplayedText(this.referrer) || ''; 

        if (!this.isWritten) {
            this.writeStream(this.text.replace(this.displayedText, '').trim(), 'displayedText')
            .then(() => {
                this.$emit('TextIsWritten');
            });
        } else {
            this.displayedText = this.text;
            this.$emit('TextIsWritten');
        }
    }
}
</script>

<style scoped>
@font-face {
    font-family: orbitron;
    src: url('../../public/assets/fonts/Orbitron-Bold.ttf');
}
</style>

<style>
.displayed-text{
    font-family: orbitron;
    font-weight: bold;
    display: inline;
    /* white-space: nowrap; */
}
.inline-cursor{
    display: inline !important;
    white-space: nowrap;
}
</style>